import { useEffect, useState } from 'react';

/**
 * Observer for browser window resizing
 * @param {number} delay Delay (in ms) between windowSize updates; use to prevent constant resizing while dragging
 * @returns Current width and height of browser window
 */
export const useObserverForResize = (delay = 0) => {
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const handleResize = () => {
      setTimeout(() => {
        setWindowSize({ width: window.innerWidth, height: window.innerHeight });
      }, delay);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
};
